import React from 'react';
import GhostContentAPI, { PostOrPage } from '@tryghost/content-api';
import { GhostAPIOptions } from '../constants';

export const useLatestRelease = (): PostOrPage | null => {
  const [
    latestReleasePost,
    setLatestReleasePost,
  ] = React.useState<PostOrPage | null>(null);
  const api = new GhostContentAPI(GhostAPIOptions);

  const getLatestReleasePost = () =>
    api.posts
      .browse({
        limit: 1, // get latest post - by default order is asc
      })
      .then(results => {
        setLatestReleasePost(results[0]);
      })
      .catch(err => {
        console.error(err);
      });

  React.useEffect(() => {
    getLatestReleasePost();
  }, []);

  return latestReleasePost;
};
